import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, Avatar, Divider } from "@mui/material";
import "./SetSalaryARModal.css";
import CustomModal from "../../CustomModal/CustomModal";
import ModalHeader from "../../CustomModal/ModalHeader";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import * as _ from "lodash";
import CompDirection from "../../../themes/CompDirection";
import { themes } from "../../../themes/themes";
import TakeActionSplitBtn from "../../../components/TakeActionSplitBtn/TakeActionSplitBtn";
import { getAmount } from "../../../configs/utils";
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  trans?: any;
  fullData?: any;
  allActions?: any;
  userId?: any;
  handleSubmitAR_Request?: any;
}

const SetSalaryARModalPresenter = ({
  isModalOpen,
  closeModal,
  fullData,
  trans,
  allActions,
  handleSubmitAR_Request,
  userId,
}: ModalProps) => {
  const handleTakeAction = (x: any) => {
    if (x) {
      const payload = {
        event: "set salary",
        instanceId: fullData?.id,
        userId: userId,
        action: x ? x : "",
        context: {},
        model: "emp_salary",
      };
      handleSubmitAR_Request(payload);
    } else {
      return;
    }
  };
  const [totalNetAmount, setTotalNetAmount] = useState(0);
  useEffect(() => {
    let amount = 0;
    fullData?.emp_salary?.allowances?.length > 0 &&
      fullData?.emp_salary?.allowances.map((am: any) => {
        return (amount = amount + am?.value);
      });
    fullData?.emp_salary?.allowances?.length > 0 &&
      fullData?.emp_salary?.other_allowances.map((am: any) => {
        return (amount = amount + am?.amount);
      });
    setTotalNetAmount(amount);
  }, [fullData]);
  return (
    <CustomModal isModalOpen={isModalOpen} modalHeight="98vh" modalWidth="35vw">
      <ModalHeader
        modal={{ modal_title: trans("Set Salary Action Required") }}
        closeModal={closeModal}
      />
      <CompDirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: "5px",
          }}
        >
          <Grid item xs={6}>
            <Box className="bg_border_ar">
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Avatar />
                <Box style={{ paddingLeft: "10px" }}>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      color: themes.darkBlue,
                      fontSize: "1em",
                      fontWeight: "bold",
                    }}
                  >
                    {fullData?.first_name} {fullData?.last_name}
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      color: themes.grey_colorDesignationAR,
                      fontSize: "0.825em",
                    }}
                  >
                    {fullData?.department_name} /{" "}
                    {fullData?.current_designation}
                  </Typography>
                </Box>
              </Box>
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography
                  style={{
                    fontFamily: "Lato",
                    color: themes.primaryMain,
                    fontSize: "0.875em",
                    fontWeight: "bold",
                  }}
                >
                  Salary Components
                </Typography>
              </Box>
              {fullData?.emp_salary?.allowances?.length > 0 &&
                fullData?.emp_salary?.allowances.map(
                  (data: any, index: any) => {
                    return (
                      <Box
                        key={index}
                        style={{
                          display: "flex",
                          padding: "1em",
                          marginTop: "0.5em",
                          width: "auto",
                          backgroundColor: "#F5F5FA66",
                          height: "30px",
                          flexDirection: "column",
                        }}
                      >
                        <Box
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginTop: "5px",
                          }}
                        >
                          <Typography
                            style={{
                              fontFamily: "Lato",
                              fontSize: "12px",
                              color: themes.greyModalTitle,
                            }}
                          >
                            {data?.title}
                          </Typography>
                          <Typography
                            style={{
                              fontFamily: "Lato",
                              fontSize: "12px",
                              fontWeight: "bold",
                              color: themes.darkBlue,
                            }}
                          >
                            {getAmount(data?.value)}
                          </Typography>
                        </Box>
                      </Box>
                    );
                  }
                )}

              <Box style={{ marginTop: "1.5em" }}>
                <CustomTextField
                  type="string"
                  label="Comment"
                  placeholder="Write Comment"
                />
              </Box>
              <Box style={{ marginTop: "1.5em", zIndex: "999", width: "100%" }}>
                <TakeActionSplitBtn
                  onAction={(x: any) => handleTakeAction(x)}
                  menu={allActions}
                  title={"Take Action"}
                />
              </Box>
            </Box>
          </Grid>
          {/* {Second Column} */}
          <Grid item xs={6}>
            <Box className="bg_border_ar">
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Typography
                  style={{
                    fontFamily: "Lato",
                    color: themes.primaryMain,
                    fontSize: "0.875em",
                    fontWeight: "bold",
                  }}
                >
                  Additional Benefits
                </Typography>
              </Box>

              {fullData?.emp_salary?.other_allowances?.length > 0 &&
                fullData?.emp_salary?.other_allowances.map(
                  (ar: any, index: any) => {
                    return (
                      <div key={index}>
                        <Box
                          style={{
                            display: "flex",
                            padding: "0.5em",
                            marginTop: "0.5em",
                            width: "auto",
                            backgroundColor: "#F5F5FA66",
                            height: "20px",
                            borderRadius: "5px",
                            flexDirection: "column",
                          }}
                        >
                          <Box
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginTop: "5px",
                            }}
                          >
                            <Typography
                              style={{
                                fontFamily: "Lato",
                                fontSize: "12px",
                                color: themes.greySubtitle,
                              }}
                            >
                              {ar?.title}
                            </Typography>
                            <Typography
                              style={{
                                fontFamily: "Lato",
                                fontSize: "12px",
                                fontWeight: "bold",
                                color: themes.greySubtitle,
                              }}
                            >
                              {ar?.amount}
                            </Typography>
                          </Box>
                        </Box>
                      </div>
                    );
                  }
                )}

              <Box
                style={{
                  display: "flex",
                  padding: "0.5em",
                  marginTop: "0.5em",
                  width: "auto",
                  backgroundColor: "#F5F5FA66",
                  height: "20px",
                  borderRadius: "5px",
                  flexDirection: "column",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: "5px",
                  }}
                >
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: themes.darkBlue,
                    }}
                  >
                    Net Salary
                  </Typography>
                  <Typography
                    style={{
                      fontFamily: "Lato",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: themes.darkBlue,
                    }}
                  >
                    {getAmount(totalNetAmount)}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </CompDirection>
    </CustomModal>
  );
};

export default SetSalaryARModalPresenter;
